"use client";

import React from "react";
import { Linkedin, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-32 bg-muted animate-pulse rounded-sm" />
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3 text-sm">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="underline decoration-transparent hover:decoration-current transition-colors duration-200 ease-in underline-offset-4 hover:text-foreground">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section id="footer" className="bg-background text-muted-foreground pt-16 pb-8 border-t border-border/40">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-16">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/HomePage" className="inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1619657/img/century_pointe_logo_footer.png" alt="Century Pointe Holdings Logo" className="h-7 w-auto object-contain" />
            </Link>
            <address className="not-italic text-sm leading-relaxed">
              Seattle, WA 98102
            </address>
          </div>

          {}
          <div>
            <h3 className="text-foreground font-medium mb-6 text-sm tracking-wide uppercase">Navigation</h3>
            <MenuProvider menu_id="42">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="text-foreground font-medium mb-6 text-sm tracking-wide uppercase">Contact</h3>
            <ul className="space-y-3 text-sm">
              <li data-index={0}>
                <Link to="tel:206-929-1309" className="underline decoration-transparent hover:decoration-current transition-colors duration-200 ease-in underline-offset-4 hover:text-foreground">
                  206-929-1309
                </Link>
              </li>
              <li data-index={1}>
                <Link to="mailto:info@centurypointeholdings.com" className="underline decoration-transparent hover:decoration-current transition-colors duration-200 ease-in underline-offset-4 hover:text-foreground">
                  info@centurypointeholdings.com
                </Link>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="text-foreground font-medium mb-6 text-sm tracking-wide uppercase">Legal & Social</h3>
            <ul className="space-y-3 text-sm mb-8">
              <li data-index={0}>
                <Link to="#" className="underline decoration-transparent hover:decoration-current transition-colors duration-200 ease-in underline-offset-4 hover:text-foreground">
                  Privacy Policy
                </Link>
              </li>
              <li data-index={1}>
                <Link to="#" className="underline decoration-transparent hover:decoration-current transition-colors duration-200 ease-in underline-offset-4 hover:text-foreground">
                  Terms of Service
                </Link>
              </li>
            </ul>
            
          </div>

        </div>

        <Separator className="bg-border/60 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs">
          <p>© {new Date().getFullYear()} Century Pointe Holdings, LLC. All rights reserved.</p>
          <p className="text-muted-foreground/80">Technological Optimization & Strategic Advisory</p>
        </div>
      </div>
    </section>;
}